import actions from '../../../constants/actionTypes';
import { getDate, isEmpty } from '../../../utils/utils';
import { EnumOrderMerchantToolFilter, EnumPage } from '../../../constants/enum';
import {
  handleChangeFilters,
  handleChangeTableActivePage,
  handleChangeTablePageSize,
  handleCloseDialogGeneric,
  handleOpenDialogGeneric,
} from '../../../redux/genericReducerHandler';
import { COMMON_CONST } from '../../../constants/constants';

const initialState = {
  itemEdit: {
    id: 0,
    merchantNoteItem: '',
    realAdultNumberItem: 0,
    commissionItem: 0,
    arisingAmountItem: 0,
  },
  filters: {
    merchant: {},
    fromDate: getDate(-6),
    toDate: getDate(5),
    status: {
      value: EnumOrderMerchantToolFilter.ALL.id,
      label: EnumOrderMerchantToolFilter.ALL.label,
    },
    orderCode: '',
    phone: '',
    isShowTotal: false,
    isAutoReload: false,
  },
  table: {
    itemList: [],
    itemData: {},
    activePage: 1,
    pageSize: COMMON_CONST.PageSize,
    extendedData: {},
  },
};

function tableReducer(state = initialState, action) {
  const { response, type } = action;
  const PAGE = EnumPage.TABLE_MANAGEMENT.id;
  switch (type) {
    case actions.OPEN_DIALOG_GENERIC: {
      return handleOpenDialogGeneric(PAGE, state, action);
    }

    case actions.CLOSE_DIALOG_GENERIC: {
      return handleCloseDialogGeneric(PAGE, state, action);
    }

    case actions.CHANGE_TABLE_ACTIVE_PAGE: {
      return handleChangeTableActivePage(PAGE, state, action);
    }

    case actions.CHANGE_TABLE_PAGE_SIZE: {
      return handleChangeTablePageSize(PAGE, state, action);
    }

    case actions.CHANGE_FILTER_GENERIC: {
      return handleChangeFilters(PAGE, state, action, initialState);
    }

    case actions.RECEIVE_LIST_TABLE_MANAGEMENT_IDS: {
      const { itemList, itemData } = response;
      return {
        ...state,
        table: {
          ...state.table,
          activePage: 1,
          itemList,
          itemData,
        },
        filters: {
          ...state.filters,
          isShowTotal: false,
        },
      };
    }

    case actions.RECEIVE_LIST_TABLE_MANAGEMENT_INFOS: {
      const { itemData } = response;
      return {
        ...state,
        table: {
          ...state.table,
          itemData: {
            ...state.table.itemData,
            ...itemData,
          },
        },
      };
    }

    case actions.CHANGE_ORDER_TABLE_ITEM: {
      const { key, value, itemEdit } = response;
      if (!isEmpty(itemEdit)) {
        return {
          ...state,
          itemEdit,
        };
      }
      return {
        ...state,
        itemEdit: {
          ...state.itemEdit,
          [key]: value,
        },
      };
    }

    case actions.RECEIVE_EXTENDED_TABLE_MANAGEMENT_INFOS: {
      const {
        extendedData,
      } = response;
      return {
        ...state,
        table: {
          ...state.table,
          extendedData,
        },
      };
    }

    default:
      return state;
  }
}

export default tableReducer;



// WEBPACK FOOTER //
// ./foody/src/pages/Table/TableManagement/reducers.js